import { render } from "./PlayerFull.vue?vue&type=template&id=59aacea6"
import script from "./PlayerFull.vue?vue&type=script&lang=js"
export * from "./PlayerFull.vue?vue&type=script&lang=js"

import "./PlayerFull.vue?vue&type=style&index=0&id=59aacea6&lang=scss"
script.render = render

export default script